import { render, staticRenderFns } from "./UserListAssignPartner.vue?vue&type=template&id=0bf285a2&"
import script from "./UserListAssignPartner.vue?vue&type=script&lang=js&"
export * from "./UserListAssignPartner.vue?vue&type=script&lang=js&"
import style0 from "./UserListAssignPartner.vue?vue&type=style&index=0&id=0bf285a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports